module.exports = __webpack_public_path__ + "img/mobile/Menus-betmenu/btn-rules-up@2x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/Menus-betmenu/btn-rules-up@2x.png
// module id = 645
// module chunks = 0